module.exports = __webpack_public_path__ + "img/1488820869.f37dad5e.jpg";